import { atom } from "jotai"
import { ConfirmDialog } from "@/components/Dialogs/ConfirmDialog"
import { Sentry } from "@/telemetry/sentry"
import { getProductName } from "@/utils/product-name"
import { isMacOnIntel } from "@/utils/system"
import { pushDialog } from "./dialogs-state"
import { store } from "./store"
// eslint-disable-next-line no-restricted-imports -- Phase 1: store-layer dialog i18n
import i18n from "@/i18n"

const intelMacAssessmentComplete = atom<boolean>(false)

export const INTEL_MAC_WARNING_SUPPRESSED_STORAGE_KEY = "suppress_intel_mac_warning"

export const __resetIntelMacAssessmentForTests = () => {
	store.set(intelMacAssessmentComplete, false)
}

function isIntelMacWarningSuppressed() {
	try {
		return globalThis.localStorage?.getItem(INTEL_MAC_WARNING_SUPPRESSED_STORAGE_KEY) === "1"
	} catch {
		return false
	}
}

export async function assessIntelMac() {
	if (store.get(intelMacAssessmentComplete)) {
		return
	}
	store.set(intelMacAssessmentComplete, true)

	if (isIntelMacWarningSuppressed()) {
		store.set(intelMacAssessmentComplete, true)
		return
	}

	let isIntel = false
	try {
		isIntel = await isMacOnIntel()
	} catch (error) {
		Sentry.captureException(error)
		return
	}

	if (!isIntel) {
		return
	}

	pushDialog(ConfirmDialog, {
		title: i18n.t("store:intelMacAssessment.intelMacTitle"),
		message: i18n.t("store:intelMacAssessment.intelMacMessage", {
			productName: getProductName(),
		}),
		canClose: true,
		trackingViewName: "intel_mac_warning",
		primary: {
			title: i18n.t("common:action.gotIt"),
			trackingLabel: "dismiss_intel_mac_warning",
		},
	})
}
